"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Typography = _interopRequireDefault(require("../../text/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Container = (0, _styledComponents["default"])(_Typography["default"]).withConfig({
  componentId: "sc-17v7s8b-0"
})(["display:flex;align-items:center;cursor:pointer;margin:0;& > svg{margin-left:4px;}"]);

function ToggleButton(_ref) {
  var className = _ref.className,
      isShowing = _ref.isShowing,
      color = _ref.color,
      onClick = _ref.onClick;
  var label = isShowing ? 'Show Less' : 'Show More';
  var iconName = isShowing ? 'chevronUp' : 'chevronDown';
  return _react["default"].createElement(Container, {
    className: className,
    color: color,
    fontSize: 0,
    onClick: onClick
  }, label, " ", _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: iconName,
    size: 24
  }));
}

ToggleButton.displayName = 'ToggleButton';
ToggleButton.propTypes = {
  className: _propTypes["default"].string,
  isShowing: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
ToggleButton.defaultProps = {
  className: '',
  color: 'primary',
  onClick: function onClick() {
    return null;
  }
};

var _default = (0, _react.memo)(ToggleButton);

exports["default"] = _default;